import { Component, Input } from '@angular/core';
import { getBusinessStepAccess } from '../../signup-user';

export interface RegStep {
  id: string;
  label: string;
  link: string;
}

@Component({
  selector: 'app-registration-stepper',
  templateUrl: './registration-stepper.component.html',
  styleUrls: ['./registration-stepper.component.scss']
})
export class RegistrationStepperComponent {
  @Input() steps: RegStep[] = [];
  @Input() currentStep = '';
  /** When true, past steps cannot be opened again (business signup). */
  @Input() lockPastSteps = false;

  get currentIndex(): number {
    return this.steps.findIndex(step => step.id === this.currentStep);
  }

  isActive(step: RegStep): boolean {
    return step.id === this.currentStep;
  }

  isCompleted(index: number): boolean {
    return index < this.currentIndex;
  }

  canNavigate(step: RegStep): boolean {
    if (!this.lockPastSteps) {
      return true;
    }
    return getBusinessStepAccess(step.id) === 'current';
  }
}
